import type { ElementType, PropsWithChildren, ReactNode } from "react";

type Props = PropsWithChildren<{
  icon: ElementType;
  primaryText: ReactNode;
  secondaryText: ReactNode;
}>;

export function ErrorPanel({
  icon: Icon,
  primaryText,
  secondaryText,
  children,
}: Props) {
  return (
    <div className="mx-auto flex max-w-xs flex-col items-center">
      <Icon
        className="size-15 border-b border-b-semantic-error-strong"
        aria-hidden
      />
      <h2 className="mt-4 text-center text-base font-medium text-black">
        {primaryText}
      </h2>
      <p className="mt-1 text-center text-sm text-text-placeholder">
        {secondaryText}
      </p>
      {children ? <div className="mt-6">{children}</div> : null}
    </div>
  );
}
